import { render } from "./GuarantorRequests.vue?vue&type=template&id=7fa0ce24"
import script from "./GuarantorRequests.vue?vue&type=script&lang=js"
export * from "./GuarantorRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__